const statisticsNumbersOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  direction: 'vertical',
  allowTouchMove: false,
  simulateTouch: false,
  watchOverflow: true,
  speed: 800,
};

const statisticsTextsOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  direction: 'vertical',
  watchOverflow: true,
  allowTouchMove: false,
  simulateTouch: false,
  speed: 800,

  thumbs: {
    swiper: false,
  },
};

const statisticsModules = document.querySelectorAll('.statistics-module');

statisticsModules.forEach((el) => {
  const numberSliderElem = el.querySelector('[data-slider="statistics-module__numbers"]');
  const textSliderElem = el.querySelector('[data-slider="statistics-module__texts"]');
  statisticsTextsOptions.thumbs.swiper = numberSliderElem;
  const fakerParent = el.querySelector('.statistics-module__faker');
  const stickyPart = el.querySelector('.statistics-module__body');
  const fakeSlides = el.querySelectorAll('.statistics-module__faker-slide');
  const pattern = el.querySelector('.statistics-module__pattern-inner');

  new Swiper(numberSliderElem, statisticsNumbersOptions);
  const textSlider = new Swiper(textSliderElem, statisticsTextsOptions);

  let controllerStatisticsModule = null;
  controllerStatisticsModule = new ScrollMagic.Controller();

  // ----
  // Sticky scene
  // ----
  const initStickyElementScene = () => {
    const scene = new ScrollMagic.Scene({
      triggerElement: fakerParent,
      duration: fakerParent.offsetHeight,
      triggerHook: 0,
    })
      .setPin(stickyPart)
      .addTo(controllerStatisticsModule);

    if (isLocal()) {
      scene.addIndicators({ name: 'Sticky' });
    }
  };

  // ----
  // Each slide entry scene
  // ----
  const slideEntryScene = () => {
    fakeSlides.forEach((el, i) => {
      const scene = new ScrollMagic.Scene({
        triggerElement: el,
        duration: el.clientHeight,
        triggerHook: 0,
      })
        .on('enter', () => {
          textSlider.slideTo(i, 800);
          gsap.to(pattern, 0.8, { y: `-${i * 140}px`, ease: 'back.out(1.7)' });
        })
        .addTo(controllerStatisticsModule);

      if (isLocal()) {
        scene.addIndicators({ name: `slide ${i}` });
      }
    });
  };

  // ----
  // Init All scene
  // ----
  const initAllScenes = () => {
    initStickyElementScene();
    slideEntryScene();
  };

  initAllScenes();
});
